"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var ShareAmp_1 = require("@/pages/common/components/amp/ShareAmp");
var mapStateToProps = function (state) { return ({
    url: state.askAnAgent.url || '',
}); };
var askAnAgentShare = function (props) {
    var hrefs = ShareAmp_1.getHrefs(props.url);
    return (React.createElement("div", { className: "c-bubble__sharebox" },
        React.createElement("a", { target: "_blank", href: hrefs.fb, className: "c-bubble__sharebtn c-bubble__sharebtn--fb" },
            React.createElement("span", { className: "fab fa-facebook-f" })),
        React.createElement("a", { target: "_blank", href: hrefs.ld, className: "c-bubble__sharebtn c-bubble__sharebtn--ld" },
            React.createElement("span", { className: "fab fa-linkedin-in" })),
        React.createElement("a", { target: "_blank", href: hrefs.wa, className: "c-bubble__sharebtn c-bubble__sharebtn--wa" },
            React.createElement("span", { className: "fab fa-whatsapp" })),
        React.createElement("a", { target: "_blank", href: hrefs.em, className: "c-bubble__sharebtn c-bubble__sharebtn--em" },
            React.createElement("span", { className: "fal fa-envelope" }))));
};
exports.default = react_redux_1.connect(mapStateToProps, function () { return ({}); })(askAnAgentShare);
